module.exports = new __parcel__URL__("wavenet-for-chrome.28edb5f0.png").toString();